import React, {useCallback, useState, useEffect} from 'react';
import {
    Page, Card, Button, Icon, Heading, TextField, Spinner
} from '@shopify/polaris';

import {TickSmallMinor} from '@shopify/polaris-icons';
import {getDeliveryEstimateForPG, updateDeliveryEstimateForVariant} from '../../services/deliveryEstimate';
import Accordion from '../Accordion';
import VariantDeliveryEstimateEdit from './VariantDeliveryEstimateEdit';
import './product.css';

function ProductDeliveryEstimate(props: any){

  const { match: { params } } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [productVariants, setProductVariants] = useState([]);
  const [accordionState, setAccordionState] = useState<any>({});

  const spinnerContainerStyle = {
    textAlign: 'center' as const,
    padding: '20px',
  };

  useEffect(() => {
    getDeliveryEstimateForPG(params.handle).then(data => {
      setProductVariants(data);
      setIsLoading(false);

      const _states: any = {};
      for(let i = 0; i < data.length; i++) {
        _states[data[i].handle] = false;
      }
      setAccordionState(_states);
    });
  }, [params.handle]);



  const getVariants = (product: any) => {
    return product.variants.map((variant: any, index: number) => {
      return (
        <div className="estimate-body" key={variant.id}>
          <div className="estimate-body__col1">
            <Heading>{variant.title}</Heading>
          </div>
          <VariantDeliveryEstimateEdit
            handle={product.handle}
            variant_id={variant.id}
            delivery_max={variant.delivery_max}
            delivery_min={variant.delivery_min} />
        </div>
      )
    });
  }

  return (<Page>
    {isLoading ? (<Card title="Delivery Estimates" sectioned><div style={spinnerContainerStyle}><Spinner accessibilityLabel="Loading Product" size="large" /></div></Card>) :
    productVariants && productVariants.length > 0 ? (
      <div>
        {productVariants.map((product: any, index: number) => {
          return (
            <Accordion label={product.title} isCollapsed={!accordionState[product.handle]} handleClick={() => {
              setAccordionState({...accordionState, [product.handle]: !accordionState[product.handle]})
            }}>
              <div className="productGroupChildren">
              <div className="estimate-header">
                <div className="estimate-header__col1">Variant</div>
                <div className="estimate-header__col2">Min</div>
                <div className="estimate-header__col3">Max</div>
                <div className="estimate-header__col4">Act</div>
              </div>
                {getVariants(product)}
              </div>
            </Accordion>
          )
        })}
      </div>
    ) : ("")}
  </Page>);
}

export default ProductDeliveryEstimate;